import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider, detectLanguage, loadLocale } from './LanguageContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for the active locale's JSON chunk (item 4 — only one of en.json/
// es.json ever loads, see LanguageContext.js) before the very first
// root.render() call. createRoot().render() is not hydration — it replaces
// #root's prerendered static content outright (see scripts/prerender.js) —
// so rendering immediately with no translations loaded yet would briefly
// blank out or show raw i18n keys over that already-correct static markup.
// Waiting the few ms for this same-origin, cached-after-first-visit chunk
// means the static homepage stays visible the whole time and is replaced
// exactly once, with real text already in place.
const initialLanguage = detectLanguage();
loadLocale(initialLanguage).then((initialTranslations) => {
  root.render(
    <React.StrictMode>
      <LanguageProvider initialLanguage={initialLanguage} initialTranslations={initialTranslations}>
        <App />
      </LanguageProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
